export default "__VITE_ASSET__74113d5e__"